import Skeleton from '@mui/material/Skeleton';

export default function ActualBook() {
    return (
        /* Adicionamos max-w-fit para o card não esticar e mx-auto para centralizar no mobile */
        <div className="flex w-full max-w-sm mx-auto dark:bg-gray-800 bg-white p-4 rounded-2xl shadow-sm gap-4 transition-all border border-gray-100 dark:border-white/5">
            {/* Lado da Capa: Shrink-0 impede que a imagem amasse */}
            <div className="shrink-0">
                <Skeleton 
                    variant="rounded" 
                    width={120} // Reduzi um pouco para caber melhor no mobile
                    height={160} 
                    animation="wave" 
                    className="rounded-xl"
                    sx={{ bgcolor: 'rgba(255,255,255,0.05)' }} // Cor mais sutil para o dark mode
                />
            </div>

            {/* Lado do Texto: flex-1 faz ele ocupar o restante do card */}
            <div className="flex flex-1 flex-col justify-between py-1">
                <div className="space-y-2">
                    {/* Título */}
                    <Skeleton variant="text" width="90%" height={25} animation="wave" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}/>
                    {/* Autor */}
                    <Skeleton variant="text" width="60%" height={20} animation="wave" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}/>
                </div>
                
                <div className="space-y-2">
                    {/* Detalhes extras ou Categoria */}
                    <Skeleton variant="text" width="100%" height={20} animation="wave" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}/>
                    {/* Botão ou Link */}
                    <Skeleton variant="rounded" width="100%" height={32} animation="wave" className="rounded-lg" sx={{ bgcolor: 'rgba(255,255,255,0.05)' }}/>
                </div>
            </div>
        </div>
    )
}